import React, { useEffect } from "react";
import { HideLoader, ShowLoader, toastError, UserToken } from "../utils/helper";
import {
    generatePolicyAsync,
    getPDFPolicyNoAsync,
} from "../redux/slice/termLifeSlice";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const KhaltiGeneratePolicy = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        processKhaltiPayment();
    }, []);

    const processKhaltiPayment = async () => {
        debugger
        try {
            ShowLoader();
            await UserToken();

            const response = await dispatch(
                generatePolicyAsync({
                    transactionDate: moment().format("YYYY-MM-DD"),
                    paymentMode: "Khalti",
                    khaltiData: {
                        pidx: searchParams.get("pidx"),
                        transaction_id: searchParams.get("transaction_id"),
                        // tidx: searchParams.get("tidx"),
                        // txnId: searchParams.get("txnId"),
                        // amount: searchParams.get("amount"),
                        // total_amount: searchParams.get("total_amount"),
                        // mobile: searchParams.get("mobile"),
                        // status: searchParams.get("status"),
                        // purchase_order_id: searchParams.get("purchase_order_id"),
                        // purchase_order_name: searchParams.get("purchase_order_name")
                    }
                })
            );
            if (response.payload.code === "100") {
                await dispatch(
                    getPDFPolicyNoAsync(response.payload.data)
                )
                    .unwrap()
                    .then((res) => {
                        if (res.code === "100") {
                            navigate("/report/policy-paper-preview", { state: res.data });
                        }
                    })
                    .catch((err) => {
                        console.error("Error generating PDF:", err);
                    });
            } else {
                toastError(response.payload.message);
                navigate("/dashboard");
            }
        } catch (error) {
            console.error(error);
            toastError("Error processing payment");
            navigate("/dashboard");
        } finally {
            HideLoader();
        }
    };
};

export default KhaltiGeneratePolicy;